
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { isGoodsValid } from '@/api/industryMall'
import { asyncDownloadUrl } from '@/utils/util'
import { ShopGoodsInfoDto } from '@/api/industryMall'
import customRadio from '@/views/industryMall/goods/components/customRadio.vue'
import priceFun from '../../shop/template/priceFun.vue'
import customizeKeyboard from '@/views/industryMall/goods/components/customizeKeyboard.vue'

@Component({
  components: {
    priceFun,
    customRadio,
    customizeKeyboard
  }
})
export default class editGoodsCard extends Vue {
  @Prop({ default: 1 }) flag!: number // 1 已上架 2：已下架
  @Prop({ default: 0 }) index!: number
  @Prop({ default: () => {} }) data!: ShopGoodsInfoDto
  @Prop({ default: false }) checkAll!: boolean // 最上层全选
  @Prop({ default: () => [] }) levelList!: Array<any>
  goodsCheckAll = false // 商品全选套餐
  isShow = false // 显示规格列表
  specsValue = 0
  packageIdList: Array<string> = [] // 选择的套餐id集合
  checkAllValue = false

  get indeterminate () {
    let allIds: Array<string> = []
    const filterPackages = this.data.goodsPackageList.filter(p => p.packageStatus === this.flag)
    allIds.push(...filterPackages.map(i => i.packageId))
    this.checkAllValue = this.packageIdList.length > 0 && this.packageIdList.length === allIds.length
    return this.packageIdList.length > 0 && this.packageIdList.length !== allIds.length
  }

  // 获取最小价格
  get minData() {
    let minPrice = 10000000000
    let saleUnitWay = ''
    let sellUnit = 1
    this.data.goodsPackageList.map((item, index) => {
      // let price = Number(item.marketPrice) / item.sellUnit
      if (item.packageStatus === this.flag) {
        let price = Number(item.marketPrice) / Number(item.sellUnit)
        if (price < minPrice) {
          minPrice = price
          sellUnit = item.sellUnit
          saleUnitWay = item.sellUnitWay
        }
      }
    })
    let textPrice = minPrice.toFixed(2)
    return { minPrice: textPrice, saleUnitWay, sellUnit }
  }

  /**
   * 处理销售方式
   */
  get handleSellDesc(): string {
    let saleArr = []
    if (this.data.goodsPackageList && this.data.goodsPackageList.length > 1) {
      saleArr = this.data.goodsPackageList.map((item) => {
        return item.packageNameDesc + item.sellUnit + item.sellUnitWay
      })
    } else {
      saleArr = this.data.goodsPackageList.map((item) => {
        return item.sellUnit + (item.sellUnitWay || '')
      })
    }
    return saleArr.join('/')
  }

  // 是否多规格
  get isMultiSpec () {
    if (this.data.goodsPackageList && this.data.goodsPackageList.length > 1) return true
    return false
  }

  @Watch('checkAll')
  checkAllChange(val) {
    this.goodsCheckAll = this.checkAll
  }

  @Watch('data')
  dataChange(val) {
    this.getImgBase(this.data.imageUrl)
    // @ts-ignore
    this.specsValue = this.data.goodsPackageList[0].marketPrice
  }

  @Watch('data.goodsPackageList')
  priceChange(val) {
    // @ts-ignore
    this.specsValue = this.data.goodsPackageList[0].marketPrice
  }

  mounted () {
    this.getImgBase(this.data.imageUrl)
    // @ts-ignore
    this.specsValue = this.data.goodsPackageList[0].marketPrice
  }

  async getImgBase (url) {
    if (this.data.urlBase) return
    let urlBase = await asyncDownloadUrl(url)
    if (!urlBase) {
      urlBase = this.$downloadUrl(url)
    }
    this.$set(this.data, 'urlBase', urlBase)
  }

  // 校验商品是否已失效/下架
  isGoodsValid() {
    const params = {
      shopId: this.data.storeId,
      goodsId: this.data.goodsId
    }
    return isGoodsValid(params)
      .then((res) => {
        if (res.data.isValid) {
          return true
        } else {
          this.$dialog
            .alert({
              message: '商品过期不存在'
            })
            .then(() => {
              this.$emit('reloadList')
            })
          return false
        }
      })
      .catch(() => {
        return false
      })
  }

  /**
   * @description 显示隐藏规格列表
   */
  openChoose() {
    if (this.data.isMultiSpec) {
      this.toDetail(this.data)
    } else {
      this.isShow = !this.isShow
    }
  }

  // 跳转商品详情
  toDetail(item: any) {
    this.$router.push({
      path: '/goodDetail',
      query: {
        goodsId: item.goodsId,
        storeId: item.storeId
      }
    })
    // this.isGoodsValid().then((res) => {
    //   if (res) {
    //     this.$router.push({
    //       path: '/goodDetail',
    //       query: {
    //         goodsId: item.goodsId,
    //         storeId: item.storeId
    //       }
    //     })
    //   }
    // })
  }

  // 选择所有套餐
  checkAllPackages (b: boolean) {
    this.goodsCheckAll = b
    this.goodsSelectFunction(b, true, '')
  }

  // 商品选择 isMain:是否主商品选择
  goodsSelectFunction (isSelect: boolean, isMain: boolean, packageId: string) {
    console.log('goodsSelectFunction ***', isSelect, isMain, packageId)
    if (isMain) {
      const ids = this.data.goodsPackageList.filter(i => i.packageStatus === this.flag).map(i => i.packageId)
      this.$emit('change', ids, isSelect)
      this.handlePackageList(ids, isSelect)
    } else {
      this.$emit('change', [packageId], isSelect)
      this.handlePackageList([packageId], isSelect)
    }
  }

  handlePackageList (ids: Array<string>, isAdd = false) {
    ids.forEach(id => {
      const targetIndex = this.packageIdList.findIndex(packageId => packageId === id)
      if (isAdd) {
        if (targetIndex === -1) this.packageIdList.push(id)
      } else {
        if (targetIndex > -1) this.packageIdList.splice(targetIndex, 1)
      }
    })
  }

  // 跳至差异定价
  toPrice (packageIndex: number) {
    const item = this.data.goodsPackageList[packageIndex]
    this.$router.push({
      path: '/differentialPricing',
      query: {
        goodsId: item.goodsId,
        packageId: item.packageId,
        marketPrice: item.marketPrice,
        sellUnit: String(item.sellUnit),
        sellUnitWay: item.sellUnitWay,
        index: String(this.index)
      }
    })
  }

  showPopup (price: string, packageIndex: number) {
    (this.$refs.keyboard as any).show(price, packageIndex)
  }

  changeVal (val: number) {
    this.$emit('changeVal', val)
  }

  blurVal (packageIndex: number) {
    // @ts-ignore
    // this.specsValue = keepDecimal(this.specsValue, 2)
    const packageId = this.data.goodsPackageList[packageIndex].packageId
    this.$emit('blurVal', packageId)
  }

  keyboardConfirm (price: string, packageIndex: number) {
    this.changeVal(Number(price))
    this.blurVal(packageIndex)
  }
}
